<span class="nc-secret-text" [style.--nc-blur-color]="ncBlurColor" [class.nc-secret-text-hover]="ncHover">
    {{ncText}}
</span>
<span class="nc-secret-text-lock" *ngIf="ncLockIcon">🔒</span>